import script from "./ApiKeysDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiKeysDetail.vue?vue&type=script&setup=true&lang=js"

import "./ApiKeysDetail.vue?vue&type=style&index=0&id=897b2f18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-897b2f18"]])

export default __exports__